import React from 'react';
import propTypes from 'prop-types';

// util
import { inferUnit } from 'util/unitConversion';
import { getMessage, currencyFormatter } from 'util/locale';
import { convertPlantingPlanParams } from 'util/parse';

// components
import PlantingPlanTextInput from './PlantingPlanTextInput';

const baseString = 'vra-planting-plan__prices__price-commodity';

const PriceCommodity = ({
  currency,
  onChangePriceCommodity,
  plantingPlanParams,
  priceCommodityValidationResult
}) => {
  const label = (
    <div>
      {getMessage('price-commodity')}&nbsp;
      <span>{inferUnit('mass.yield').symbol.quantitySpecific}</span>
    </div>
  );

  const { display, displayValue } = convertPlantingPlanParams({
    validationResult: priceCommodityValidationResult,
    value: plantingPlanParams['price-commodity'],
    currency
  });

  return (
    <section className={baseString}>
      <PlantingPlanTextInput
        className={`${baseString}__input`}
        dataTestId='price-commodity-input'
        displayValue={displayValue}
        label={label}
        onChange={onChangePriceCommodity}
        placeholder={currencyFormatter(0, currency)}
        validationResult={priceCommodityValidationResult}
        value={display}
      >
        <span className='vra-planting-plan-form__inputs-units'>
          {`/${inferUnit('mass.yield').symbol.quantitySpecific}`}
        </span>
      </PlantingPlanTextInput>
    </section>
  );
};
PriceCommodity.propTypes = {
  currency: propTypes.string.isRequired,
  onChangePriceCommodity: propTypes.func.isRequired,
  plantingPlanParams: propTypes.object.isRequired,
  priceCommodityValidationResult: propTypes.object
};
export default PriceCommodity;
